import { createStore } from 'redux';
import rootReducer from '../reducers';

const reduxDevTools = (window as any).__REDUX_DEVTOOLS_EXTENSION__;

let store = createStore(rootReducer);

if (process.env.NODE_ENV !== 'production') {
  store = createStore(rootReducer, reduxDevTools && reduxDevTools());
}

export default store;
